import React from 'react';

const AdminTabs = ({ handleSelection, activeTab }) => {
  return (
      <ul className="tabs">
        <li onClick={ () => handleSelection('overview') } className={ activeTab === 'overview' ? 'active' : '' }>Overview</li>
        <li onClick={ () => handleSelection('slides') } className={ activeTab === 'slides' ? 'active' : '' }>Slides</li>
        <li onClick={ () => handleSelection('credits') } className={ activeTab === 'credits' ? 'active' : '' }>Credits</li>
      </ul>)
};

export default AdminTabs;



// WEBPACK FOOTER //
// ./src/components/AdminTabs/AdminTabs.js